import type { Texts } from '../useTexts'

export const createValidateSurname = (texts: Texts, surname: string) => {
  const requiredError = surname.length === 0
  const maxLengthError = surname.length > 30

  const surnameRequiredError = {
    id: 'surnameRequiredError',
    message: texts.errors.required('user surname'),
    field: 'surname' as const,
    priority: 10,
  }

  const surnameMaxLengthError = {
    id: 'surnameMaxLengthError',
    message: texts.errors.maxLength(30),
    field: 'surname' as const,
    priority: 10,
  }

  return {
    [surnameRequiredError.id]: requiredError ? surnameRequiredError : undefined,
    [surnameMaxLengthError.id]: maxLengthError ? surnameMaxLengthError : undefined,
  }
}
